<style lang="scss" scoped>
.el-form {
  margin-bottom: 10px;
}

.screen-content {
  position: relative;

  .download {
    position: absolute;
    top: 5px;
    right: 30px;
    z-index: 99;

    a {
      color: #1d9dda;
    }
  }
  .condition-all-form {
    .el-form-item {
      /deep/ .el-tag {
        .el-select__tags-text {
          display: inline-block;
          max-width: 280px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .el-tag__close {
          top: -7px;
        }
      }
    }
  }

  .condition-all-form {
    .conditions-list {
      // margin: 10px 0;
      margin-bottom: 10px;
    }
  }
}

.table-content {
  margin: 20px 0;
}

.echarts-model {
  width: 100%;
  height: 400px;
}
</style>

<template>
  <div class="content">
    <div class="screen-content">
      <div class="download">
        <a href="#" @click="onDownloadExcel">下载报表</a>
      </div>
      <div v-for="(attr, index) in attrAll" :key="index">
        <el-form
          :ref="attr.tag"
          :class="attr.tag + '-form'"
          :disabled="loading"
          label-width="auto"
          size="small"
        >
          <el-form-item :label="attr.name" v-if="attr.tag === 'kpi-event-all'">
            <el-cascader
              clearable
              separator=" > "
              v-model="staFormData.kpiEvents"
              :options="attr.children"
              :props="{
                expandTrigger: 'hover',
                label: 'name',
                value: 'id',
                multiple: true,
                emitPath: false
              }"
              @change="onHandleChange($event, attr.tag)"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="attr.name" v-else-if="attr.tag === 'dimension-all'">
            <el-cascader
              clearable
              separator=" > "
              @change="onHandleChange($event, attr.tag)"
              :options="attr.children"
              :props="{
                expandTrigger: 'hover',
                label: 'name',
                value: 'id',
                multiple: true,
                emitPath: false
              }"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="attr.name" v-else-if="attr.tag === 'user-type-all'">
            <el-cascader
              clearable
              separator=" > "
              placeholder="不限 > 不限"
              @change="onHandleChange($event, attr.tag)"
              :options="attr.children"
              :props="{
                expandTrigger: 'hover',
                label: 'name',
                value: 'value'
              }"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="attr.name" label-width="auto" v-else-if="attr.tag === 'condition-all'">
            <div
              v-for="(item, index) in staFormData.conditions"
              class="conditions-list"
              :key="index"
            >
              <el-cascader
                clearable
                separator=" > "
                v-model="staFormData.conditions[index].id"
                :options="attr.children"
                :disabled="staFormData.conditions[index].alldisabled"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'id',
                  emitPath: false,
                }"
                @change="onHandleChange($event, attr.tag, index)"
              ></el-cascader>
              <el-tooltip
                :disabled="staFormData.conditions[index].symbol !== 'lk'"
                class="item"
                effect="dark"
                content="可以用英文 ? 匹配单个字符或 * 匹配 0 或多个字符"
                placement="top-start"
              >
                <el-select
                  style="width: 100px; margin: 0 10px;"
                  placeholder="包含"
                  v-model="staFormData.conditions[index].symbol"
                  @change="onHandleChange($event, 'screen', index)"
                  :disabled="staFormData.conditions[index].disabled || staFormData.conditions[index].alldisabled"
                >
                  <el-option label="是" value="eq"></el-option>
                  <el-option label="不是" value="ne"></el-option>
                  <el-option label="包含" value="ct"></el-option>
                  <el-option label="不包含" value="nc"></el-option>
                  <el-option label="通配符" value="lk"></el-option>
                </el-select>
              </el-tooltip>
              <el-select
                style="width: 350px; margin-right: 10px;"
                v-model="staFormData.conditions[index].value"
                :multiple="scrInputType"
                :clearable="!staFormData.conditions[index].clearable"
                filterable
                allow-create
                default-first-option
                :disabled="staFormData.conditions[index].disabled || staFormData.conditions[index].alldisabled"
                v-loading="staFormData.conditions[index].isLoading"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.1)"
                placeholder="增加条件用回车键分隔"
              >
                <el-option
                  v-for="(item, index2) in staFormData.conditions[index].option"
                  :key="index2"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-button icon="el-icon-delete" v-if="!staFormData.conditions[index].alldisabled" circle @click="onDelConditionsItem(index)"></el-button>
            </div>
            <el-button icon="el-icon-plus" circle @click="onAddConditionsItem"></el-button>
          </el-form-item>
        </el-form>
        
        <el-form
          ref="logic"
          class="logic-form'"
          label-width="auto"
          v-if="attr.tag === 'condition-all' && staFormData.conditions && staFormData.conditions.length >= 2"
          size="small"
        >
          <el-form-item label="筛选条件关系">
            <el-select v-model="staFormData.logic" placeholder="条件关系">
              <el-option label="且" value="and"></el-option>
              <el-option label="或" value="or"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-row>
        <el-button size="small" type="primary" @click="onStartAnalyze()" :loading="loading">开始分析</el-button>
      </el-row>
    </div>
    <div class="table-content" v-loading="loading">
      <el-row>
        <el-col :span="24">
          <el-form label-width="auto" class="screnTime">
            <el-form-item label-width="auto">
              <el-date-picker
                type="daterange"
                size="small"
                value-format="timestamp"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                v-model="modelControl.time"
                :default-time="['00:00:00', '23:59:59']"
                :picker-options="pickerOptions"
                :disabled="loading"
                @change="onHandleChange($event, 'screnTime')"
              ></el-date-picker>
              <el-select
                style="margin-left: 5px; width: 100px;"
                size="small"
                v-model="staFormData.dateInterval"
                :disabled="loading"
                @change="onHandleChange($event, 'changDateInterval')"
              >
                <!-- <el-option label="按分钟" value="minute"></el-option> -->
                <!-- <el-option label="按小时" value="hour"></el-option> -->
                <el-option label="按天" value="day"></el-option>
                <el-option label="按星期" value="week"></el-option>
                <el-option label="按月" value="month"></el-option>
                <el-option label="按季度" value="quarter"></el-option>
                <el-option label="按年" value="year"></el-option>
              </el-select>
              <el-select
                style="margin-left: 5px; width: 100px;"
                size="small"
                v-model="modelControl.modelType"
                :disabled="loading"
                @change="onHandleChange($event, 'changModelType')"
              >
                <el-option label="表格" value="table"></el-option>
                <el-option label="折线" value="line"></el-option>
                <el-option label="柱状" value="bar"></el-option>
                <el-option label="饼图" value="pie"></el-option>
                <!-- <el-option label="数值图" value="c?"></el-option> -->
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-select
            style="margin-left: 5px; width: 20%;"
            size="small"
            placeholder="显示指标"
            v-model="showKpi"
            v-show="modelControl.modelType !== 'table'"
            :disabled="loading"
            @change="onHandleChange($event, 'showKpi')"
          >
            <el-option
              v-for="(kpi, index) in modelControl.showKpiArr"
              :key="index"
              :label="kpi"
              :value="kpi"
            ></el-option>
          </el-select>
          <el-select
            style="margin-left: 5px; width: 70%;"
            size="small"
            placeholder="显示分组"
            multiple
            clearable
            filterable
            collapse-tags
            v-model="showDimensions"
            v-show="modelControl.modelType !== 'table'"
            :disabled="loading"
            @change="onHandleChange($event, 'showDimensions')"
          >
            <el-option
              v-for="(dimension, index) in modelControl.showDimensionsArr"
              :key="index"
              :label="dimension"
              :value="dimension"
            >
              <span
                style="max-width: 400px;float: left;margin-right:20px;overflow:hidden;text-overflow: ellipsis;"
              >{{ dimension }}</span>
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="table-model" v-show="modelControl.modelType === 'table'">
        <el-table :data="modelData" style="width: 100%" id="table" max-height="450" size="small">
          <el-table-column
            v-for="(dimension, key, index) in modelData[0]"
            :key="index"
            :label="key.split('-')[1]"
            :prop="key"
            :sortable="(key.split('-')[0] === 'time' | key.split('-')[0] === 'kpi' ? true : false)"
          >
            <!-- <template slot-scope="scope">
              <p v-if="key==='time-时间'">{{ scope.row[key].split('T')[0] }}</p>
              <p v-else>{{ scope.row[key] }}</p>
            </template>-->
          </el-table-column>
        </el-table>
      </div>
      <div ref="echart" class="echarts-model" v-show="modelControl.modelType !== 'table'"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Echarts from "echarts";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import config from "@/config/index";
import { setTreeData, reverseObject } from "@/common/util";

import {channel} from "../../../plugins/dictionary.js";

export default {
  data() {
    return {
      // 搜索属性
      attrAll: [],
      // 搜索原始数据
      basicData:[],
      // 综合统计表单数据
      staFormData: {
        // 搜索条件列表
        conditions: [],
        // 时间间隔（minute；hour；day；week；month；quarter, year）
        dateInterval: "day",
        // 事件指标列表
        kpiEvents: ["ca634f0d083b4aa9a55c7bf5209b6688"],
        // 用户类型 （a-a）
        userType: "a-a",
        // 开始时间
        startTime: "",
        // 结束时间
        endTime: ""
        // 维度列表
        // dimensions: [],
        // 逻辑运算（and：且；or：或）
        // logic: ""
      },
      //
      // 表格分析模型数据
      modelData: [],
      // 时间选择器配置
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              start.setMilliseconds(0);
              start.setTime(start.getTime());
              end.setTime(start.getTime() + 3600 * 1000 * 24 - 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setHours(0);
              start.setMinutes(0);
              start.setSeconds(0);
              start.setMilliseconds(0);
              end.setTime(start.getTime() - 1);
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "过去七天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          }
          // {
          //   text: "过去一个月",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          //     picker.$emit("pick", [start, end]);
          //   }
          // }
        ]
      },
      //model控制配置
      modelControl: {
        // 时间
        time: [],
        // 展示类型
        modelType: "table",
        showKpiArr: [],
        showDimensionsArr: []
      },
      // model loading状态
      loading: false,
      // 要显示在model上的指标类型
      showKpi: "",
      // 要显示在model上的维度组合
      showDimensions: [],
      option: {},
      // 筛选条件单选还是多选
      scrInputType: false,

    };
  },
  created() {
    // 获取搜索参数
    this.getAttrAll(false);

    // 设置默认时间
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    this.modelControl.time = [start, end];
    this.staFormData.startTime = start;
    this.staFormData.endTime = end;
  },
  methods: {
    /**
     * 获取所有的搜索参数
     */
    getAttrAll(load = true) {
      this.$ajax(
        "/web/search_properties/page",
        {
          pageNo: 0,
          pageSize: 1000
        },
        {
          method: "get",
          load
        }
      ).then(result => {
        if (result.status === 200) {
          let attrData = setTreeData(result.data.content, true);
          this.basicData = result.data.content;
          this.setDefaultChannelSelect(this.basicData)
          attrData = attrData.filter(function(item) {
            return item.type === "general-statistic" && item.tag === "all";
          });
          let attrAll = attrData[0]["children"];
          let lookwd;
          attrAll.forEach((item,index)=>{
            if(item.tag == "dimension-all"){
              lookwd = attrAll.splice(index,1)
              return
            }
          })
          attrAll.forEach((item,index)=>{
            if(item.tag == "condition-all" && lookwd){
              attrAll.splice(index+1,0,...lookwd)
              return
            }
          })
          this.attrAll = attrData[0]["children"];
        }
      });
    },
     /**
     * 频道筛选默认自动选上
     */
    setDefaultChannelSelect(list){
      list = list || [];
      list.forEach(item=>{
        if(item.tag === "condition-source" && item.value === "properties.platFormDesc.keyword"){
          let channelText = this.$route.params.channel.replace(/(\s*$)/g, "");
          this.onAddConditionsItem()
          this.staFormData.conditions[0].id = item.id
          this.staFormData.conditions[0].value = channel[channelText]
          this.staFormData.conditions[0].alldisabled = true
        }
      })
    },
    /**
     * 获取结果展示模块数据
     */
    getModelData() {
      let _vue = this;
      // 关闭loading状态
      this.loading = true;
      this.staFormData.conditions.forEach(function(item) {
        if (item.value instanceof Array) {
          item.value = item.value.join(",");
        }
      });
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
      // 发送ajax
      return Axios({
        method: "post",
        url: config.API +  "/web/general/statistics",
        headers:{
          "Authorization":userInfo.jti
        },
        data: {
          ...this.staFormData
        }
      })
        .then(result => {
          if (result.data.status === 200) {
            let modelData = result.data.data;
            let time = new Date();
            // 反转对象，把时间排到第一位, 根据时间分类修改日期格式
            modelData.forEach((data, index) => {
              time.setTime(Date.parse(data["time-时间"]));
              if (this.staFormData.dateInterval === "day") {
                data["time-时间"] = `${time.getFullYear()}年${time.getMonth() +
                  1}月${time.getDate()}日`;
              }
              if (this.staFormData.dateInterval === "week") {
                data["time-时间"] = `${time.getFullYear()}年${time.getMonth() +
                  1}月${time.getDate()}当周`;
              }
              if (this.staFormData.dateInterval === "month") {
                data["time-时间"] = `${time.getFullYear()}年${time.getMonth() +
                  1}月`;
              }
              if (this.staFormData.dateInterval === "quarter") {
                data["time-时间"] = `${time.getFullYear()}年${time.getMonth() +
                  1}当季`;
              }
              if (this.staFormData.dateInterval === "year") {
                data["time-时间"] = `${time.getFullYear()}年`;
              }
              modelData[index] = reverseObject(data);
            });

            // 临时保存指标和分组配置
            let sKpiL = [],
              sDimensionsL = new Set();

            modelData.forEach((date, index) => {
              let showDimensionsItem = [];
              for (const key in date) {
                let sType = key.split("-");
                // 生成事件指标配置
                if (index === 0 && sType[0] === "kpi") {
                  sKpiL.push(sType[1]);
                }
                // 生成查看维度配置
                if (sType[0] === "dimension") {
                  showDimensionsItem.push(date[key]);
                }
              }
              sDimensionsL.add(showDimensionsItem.join(","));
            });
            // 赋值
            this.modelControl.showKpiArr = sKpiL;
            this.modelControl.showDimensionsArr = [...sDimensionsL];
            this.modelData = modelData;
            return modelData;
          } else {
            _vue.$message.error(result.data.msg || "系统异常");
            return result.data.msg || "系统异常";
          }
        })
        .finally(() => {
          // 关闭loading状态
          this.loading = false;
        });
    },
    /**
     * 获取单个搜索条件的值
     */
    getScrArr(id, load = true) {
      return this.$ajax(
        "/web/general/options/" + id,
        {},
        {
          method: "post",
          nSplitUrl: true,
          load
        }
      ).then(result => {
        if (result.status === 200) {
          return result.data || [];
        }
      });
    },
    /**
     * model数据处理
     * @param {String} kpi 要显示的指标
     * @param {Array} dimensions 要显示的维度组合数组
     * @param {String} modelType 要显示的model类型
     * @param {Array} modelData 要显示的model数据
     */
    conductModelData(kpi, dimensions, modelType, modelData) {
      let option = {
        title: {
          text: "事件分析",
          subtext: this.showKpi
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true }
          }
        },
        legend: {
          type: "scroll",
          right: 100,
          left: 100
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        tooltip: {
          trigger: "none"
        },
        series: []
      };
      // 如果是饼图
      if (modelType === "pie") {
        let seriesItem = {
          type: "pie",
          radius: "55%",
          center: ["50%", "50%"],
          data: [{ value: 0, name: "未分类" }]
        };
        modelData.forEach(data => {
          // 计算总数
          for (const key in data) {
            let sType = key.split("-");
            if (sType[1] === kpi) {
              seriesItem.data[0].value += data[key];
            }
          }
        });
        dimensions.forEach(dimension => {
          let seriesDataItem = { value: 0, name: dimension };
          // 获取对应维度组合的对应指标的值
          modelData.forEach(data => {
            // 获取对应时间和维度组合的对应指标的值
            let dimensionStr = [],
              kpiL = 0;

            for (const key in data) {
              let sType = key.split("-");
              if (sType[0] === "dimension") {
                dimensionStr.push(data[key]);
              }
              if (sType[1] === kpi) {
                kpiL = data[key];
              }
            }
            if (dimension === dimensionStr.join(",")) {
              seriesDataItem.value += kpiL;
            }
          });
          seriesItem.data[0].value -= seriesDataItem.value;
          seriesItem.data.push(seriesDataItem);
        });
        option.series = [seriesItem];
        option.tooltip.trigger = "item";
      }
      // 不是饼图
      if (modelType !== "pie") {
        // 用来保存modelx轴（时间）的值并去重
        let xAxis = new Set();
        modelData.forEach(data => {
          for (const key in data) {
            let sType = key.split("-");
            if (sType[0] === "time") {
              xAxis.add(data[key]);
            }
          }
        });
        // 添加维度
        option.dataset = { source: [["product", ...dimensions]] };
        // 创建x轴数据
        xAxis.forEach(xA => {
          let xAA = [xA.split("T")[0]];
          dimensions.forEach((dimension, i) => {
            xAA[i + 1] = 0;
            this.modelData.forEach(data => {
              let dimensionStr = [],
                time = "",
                kpiL = null;
              // 获取对应时间和维度组合的对应指标的值
              for (const key in data) {
                let sType = key.split("-");
                time = data["time-时间"];
                if (sType[0] === "dimension") {
                  dimensionStr.push(data[key]);
                }
                if (sType[1] === kpi) {
                  kpiL = data[key];
                }
              }
              if (xA === time && dimension === dimensionStr.join(",")) {
                xAA[i + 1] = kpiL;
              }
            });
          });
          option.dataset.source.push(xAA);
        });

        option.xAxis = { type: "category" };
        option.yAxis = {};
        option.tooltip.trigger = "axis";

        for (let i = 0; i < dimensions.length; i++) {
          // 添加维度图
          if (modelType === "bar") {
            option.series.push({
              type: modelType,
              stack: kpi
            });
          }
          if (modelType === "line") {
            option.xAxis.boundaryGap = false;
            option.series.push({
              type: modelType,
              smooth: true
            });
          }
        }
      }
      this.option = option;
      return option;
    },
    /**
     * 开始分析,生成图表
     * @param {Boolean} setdeft 是否设置默认显示的指标和维度
     */
    onStartAnalyze() {
      const modelType = this.modelControl.modelType;
      // 获取数据
      this.getModelData().then(modelData => {
        if (modelData instanceof Array && modelData.length) {
          this.modelData = modelData;
          if (modelType != "table") {
            if (!this.showKpi.length && !this.showDimensions.length) {
              this.showKpi = this.modelControl.showKpiArr[0];
              if (this.modelControl.showDimensionsArr.length > 1) {
                let sDi = [];
                for (let i = 0; i < 4; i++) {
                  if (!this.modelControl.showDimensionsArr[i]) break;
                  sDi.push(this.modelControl.showDimensionsArr[i]);
                }
                this.showDimensions = sDi;
              } else {
                this.showDimensions = [""];
              }
            }

            // 生成配置项和数据
            let option = this.conductModelData(
              this.showKpi,
              this.showDimensions,
              modelType,
              modelData
            );

            // 使用刚指定的配置项和数据显示图表。
            let myChart = Echarts.init(this.$refs["echart"]);
            myChart.setOption(option, true);
            window.onresize = myChart.resize;
          }
        }
      });
    },
    /**
     * 选择筛选参数
     * @param {Array | String} value 选择的值
     * @param {String} type 类型
     */
    onHandleChange(value, type, index, option) {
      switch (type) {
        case "kpi-event-all":
          break;
        case "screen":
          switch (value) {
            case "eq":
            case "ne":
            case "lk":
              this.scrInputType = false;
              typeof this.staFormData.conditions[index].value !== "string" &&
                (this.staFormData.conditions[index].value = "");
              break;
            case "ct":
            case "nc":
              this.scrInputType = true;
              !(this.staFormData.conditions[index].value instanceof Array) &&
                (this.staFormData.conditions[index].value = []);
              break;
            default:
              break;
          }
          break;
        case "condition-all":
          let filterData = this.basicData.filter(item=>item.id === value); 
          let ispFormDesc = filterData.some(item=>item.value === "properties.platFormDesc.keyword");
          if(ispFormDesc){
            this.staFormData.conditions[index].option = []
            this.staFormData.conditions[index].disabled = true
            let channelText = this.$route.params.channel.replace(/(\s*$)/g, "");
            this.staFormData.conditions[index].value = channel[channelText]
          }else{
            this.getScrArr(value).then(res => {
              this.staFormData.conditions[index].option = res;
              this.staFormData.conditions[index].value = "";
              this.staFormData.conditions[index].disabled = false
            });
          }
          
          break;
        case "dimension-all":
          // 不是接口必须参数 有值就添加到查询参数内，没有就删掉
          value.length
            ? (this.staFormData.dimensions = value)
            : delete this.staFormData.dimensions;
          break;
        case "user-type-all":
          // 不是接口必须参数 有值就添加到查询参数内，没有就删掉
          value.length
            ? (this.staFormData.userType = value.join("-"))
            : delete this.staFormData.userType;
          break;
        case "screnTime":
          if (value && value.length) {
            this.staFormData.startTime = value[0];
            this.staFormData.endTime = value[1];
            this.$nextTick(function() {
              this.onStartAnalyze();
            });
          } else {
            this.staFormData.startTime = "";
            this.staFormData.endTime = "";
          }
          break;
        case "changDateInterval":
        case "changModelType":
        case "showKpi":
        case "showDimensions":
          this.$nextTick(function() {
            this.onStartAnalyze();
          });
          break;
        default:
          break;
      }
    },
    /**
     * 添加筛选条件
     */
    onAddConditionsItem() {
      if (this.staFormData.conditions) {
        this.staFormData.conditions.push({
          id: "",
          symbol: "eq",
          value: "",
          // valueArr: [],
          option: [],
          isLoading: false
        });
      } else {
        this.staFormData.conditions = [
          {
            id: "",
            symbol: "eq",
            value: "",
            // valueArr: [],
            option: [],
            isLoading: false
          }
        ];
      }
    },
    /**
     * 删除筛选条件
     * @param {Number} index
     */
    onDelConditionsItem(index) {
      this.staFormData.conditions.splice(index++, 1);
      if (this.staFormData.logic && this.staFormData.conditions.length <= 1) {
        delete this.staFormData.logic;
      }
    },
    /**
     * 下载报表
     */
    onDownloadExcel() {
      /* 从表生成工作簿对象 */
      const wb = XLSX.utils.table_to_book(document.querySelector("#table"));
      /* 获取二进制字符串作为输出 */
      const wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "事件分析.xlsx"
        );
      } catch (e) {
        this.$message.error("文件下载失败");
      }
      return wbout;
    }
  }
};
</script>
